module.exports = __webpack_public_path__ + "static/media/image-card-2.f81acd81.png";